"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../sectionSubtitle/styles");
exports.Title = styled_components_1.default.div `
  margin: 0;

  ${({ theme }) => theme.typography.heading.small};

  color: ${({ theme }) => theme.colors.neutral.n800};

  + ${styles_1.Subtitle} {
    margin-top: ${({ theme }) => theme.space.s050};
  }
`;
